import { z } from 'zod';

import { JSONObject, JSONValue } from '@Common/types/json';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

const literalSchema = z.union([ZodTrimmedString, z.number(), z.boolean(), z.null()]);

export const ZodJSON: z.ZodType<JSONValue> = z.lazy(() =>
  z.union([literalSchema, z.array(z.any()), z.record(ZodTrimmedString, z.any())]),
);

export const ZodJSONObject: z.ZodType<JSONObject> = z.lazy(() =>
  z.record(ZodTrimmedString, z.any()),
);
